import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonGroup, useMediaQuery, useTheme, alpha } from '@mui/material';
const StyledButtonGroupUndertaking = ({ buttons, variant = 'outlined', size = 'large', fullWidth = true, orientation = 'horizontal', sx = {} }) => {
    const theme = useTheme();
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsx(ButtonGroup, { variant: variant, size: size, fullWidth: fullWidth, orientation: orientation, sx: {
            borderRadius: 2,
            overflow: 'hidden',
            '& .MuiButton-root': {
                flex: 1,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.95rem',
                transition: 'all 0.2s ease'
            },
            ...sx
        }, children: buttons.map((btn, index) => {
            // Safely extract a custom background color (if any)
            const customBg = typeof btn.buttonProps?.sx === 'object' && !Array.isArray(btn.buttonProps.sx)
                ? btn.buttonProps.sx?.backgroundColor
                : undefined;
            const colorMap = {
                primary: theme.palette.primary.main,
                error: theme.palette.error.main,
                info: theme.palette.info.main,
                neutral: theme.palette.grey[400],
                custom: customBg || theme.palette.grey[200]
            };
            const baseColor = colorMap[btn.colorType || 'primary'];
            const bgColor = btn.active ? baseColor : 'transparent';
            const textColor = btn.active ? theme.palette.common.white : baseColor;
            const borderColor = baseColor;
            return (_jsx(Button, { onClick: btn.onClick, startIcon: !isSmallerScreen && btn.icon, endIcon: !isSmallerScreen && btn.endIcon, disabled: btn.disabled, sx: {
                    backgroundColor: bgColor,
                    color: textColor,
                    border: `1px solid ${borderColor}`,
                    '& .MuiSvgIcon-root, & .MuiButton-startIcon, & .MuiButton-endIcon': {
                        color: textColor // make icons same color as text
                    },
                    '&.MuiButton-outlined': {
                        borderColor: borderColor
                    },
                    '&:hover': {
                        backgroundColor: alpha(baseColor, 0.9),
                        color: theme.palette.common.white,
                        '& .MuiSvgIcon-root, & .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: theme.palette.common.white
                        }
                    },
                    ...btn.buttonProps?.sx
                }, ...btn.buttonProps, children: btn.label }, index));
        }) }));
};
export default StyledButtonGroupUndertaking;
